module.exports = __webpack_public_path__ + "static/media/AKHIRPEKAN1.e7fdc5ea.png";